<div class="bg" style="display: flex; flex-direction: column; align-items: center;">
  <!--Adding-->
    <div style="display: flex; align-items: center;">
        <h1 style="text-align: center; margin-top: 25px;">An alumni to add ?</h1>
        <button class="buttonajout" (click)="openModal()">Add Alumni</button>
    </div>
    <hr style="width: 80%; margin-top: 10px; margin-bottom: 10px;">
      Search
   <div class="search__container">
    <input
      type="text"
      #myInput
      [(ngModel)]="nom"
      (input)="SearchPostByTitre()"
      class="search__input"
      placeholder="Search …"
    />
    <input
      [hidden]="true"
      type="text"
      #myInput
      [(ngModel)]="date"
      (input)="SearchPostByDate()"
      class="search__input"
      placeholder="Search …"
    />
  </div>
 

  <div class="button-container">
    <button class="custom-button mission-button">
      <span class="button-text">Mission</span>
    </button>
    <button class="custom-button gender-button">Gender</button>
    <div>
      <input type="date" class="custom-button date-input">
    </div>
  </div>
  
   
   
    <!--Cards
    <div class="card-container">
        <div class="card">
            <img class="card-image" src="../../../assets/images/alumniblue.png" alt="Image 1">
            Math Departement
        </div>
        
        <div class="card">
            <img class="card-image" src="../../../assets/images/alumniorange.png" alt="Image 2">
            IT Departement
        </div>
        <div class="card">
            <img class="card-image" src="../../../assets/images/alumnipurple.png" alt="Image 3">
            Video Games departement
        </div>
        <div class="card">
            <img class="card-image" src="../../../assets/images/alumnigreen.png" alt="Image 4">
            Multimedia Departement
        </div>
    </div>
    -->
       <!--Table Data-->
    <div style="padding-top: 15px;">
    <hr style="width: 80%; margin-top: 10px; margin-bottom: 10px;">
</div>
 <!-- tableau -->
<table class="custom-table">
    <thead>
      <tr>
        <th>Full name</th>
        <th>Gender</th>
        <th>Mission</th>
        <th>Session <i class="fas fa-edit edit-icon" ></i></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let alumni of ListAlumni">
        <td>
          <div class="name-column">
            <img class="profile-photo" src="http://localhost:9091/User/{{ alumni.coverImage }}" alt="Med Ali Jlassi">
          <a [routerLink]="['/consultalumni',alumni._id]">{{alumni.nom}}</a> {{alumni.prenom}}
          </div>
        </td>
        <td>Male</td>
        <td>{{alumni.departement}}</td>
        <td>{{alumni.session}} 
          <a [routerLink]="['/updatealumni', alumni._id]">
          <i class="fas fa-edit edit-icon"></i></a>
          <a (click)="openalert(contentalert);setAlumniId(alumni._id)">
            <i class="fas fa-trash-alt delete-icon red-icon"></i>
          </a>

        </td>

      </tr>
   
    
    </tbody>
  </table>

<!-- Add Alumni Modal -->
<div id="myModal" class="modal" style="display:none;" >
    <div class="modal-dialog" style="width: 80%;">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Alumni Add Form</h4>
          <button type="button" class="close" (click)="closeModal()">&times;</button>
        </div>
        
        <!-- Modal Body -->
        <div class="modal-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="nom">Short Name</label>
              <input type="text" formControlName="nom" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.nom.errors }" />
              <div *ngIf="submitted && f.nom.errors" class="invalid-feedback">
                <div *ngIf="f.nom.errors.required">Short Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="prenom">Full Name</label>
              <input type="text" formControlName="prenom" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.prenom.errors }"/>
              <div *ngIf="submitted && f.prenom.errors" class="invalid-feedback">
                <div *ngIf="f.prenom.errors.required">Full Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Invalid email format</div>
              </div>
            </div>
            <div class="form-group">
              <label for="tel">Phone Number</label>
              <input type="number" formControlName="tel" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.tel.errors }" />
              <div *ngIf="submitted && f.tlf.errors" class="invalid-feedback">
                <div *ngIf="f.tel.errors.required">Phone Number is required</div>
                <div *ngIf="f.tel.errors.minlength || f.tel.errors.maxlength">Phone Number must be 8 characters long</div>
              </div>
            </div>
            
            <div class="form-group">
              <label for="sex">Sex</label>
              <select formControlName="sex" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.sex.errors }">
                <option value="">Select sex</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <div *ngIf="submitted && f.sex.errors" class="invalid-feedback">
                <div *ngIf="f.sex.errors.required">Sex is required</div>
              </div>
            </div>
              
            <div class="form-group">
              <label for="session">Session</label>
              <input type="date" formControlName="session" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.session.errors }" />
              <div *ngIf="submitted && f.session.errors" class="invalid-feedback">
                <div *ngIf="f.session.errors.required">Session is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="departement">Department</label>
              <input type="text" formControlName="departement" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.departement.errors }" />
              <div *ngIf="submitted && f.departement.errors" class="invalid-feedback">
                <div *ngIf="f.departement.errors.required">Department is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="awards">Awards</label>
              <input type="text" formControlName="awards" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.awards.errors }" />
              <div *ngIf="submitted && f.awards.errors" class="invalid-feedback">
                <div *ngIf="f.awards.errors.required">Awards is required</div>
            </div>
            </div>
            <div class="form-group">
            <button class="btn btn-outline-dark">Add</button>
            <a class="btn btn-link" type="reset" href="/home/gestion-alumni" (click)="closeModal()">Cancel</a>
            </div>
            
            </form>
            </div>
            </div>
            
              </div>
            </div>
<!-- Delete Alumni Modal -->

<ng-template #contentalert let-modal>
  <div class="modal-header">
    <h5
      style="color: black; text-align: center"
      class="modal-title"
      id="modal-basic-title"
    >
      Are You Sur to delete this Alumni from database ?
    </h5>
    <a href="/home/gestion-alumni">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </a>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group" style="align-items: center">
        <a
          style="color: red"
          href="/home/gestion-alumni"
          class="btn btn-default"
          (click)="deleteAlumni(); modal.dismiss('Cross click')"
          >Confirm</a
        >
        <a
          style="color: green"
          class="btn btn-link"
          class="btn btn-default"
          href="/home/gestion-alumni"
          (click)="modal.dismiss('Cross click')"
          >Cancel</a
        >
      </div>
    </form>
  </div>
</ng-template>





            </div>

    